import { types } from '~/store/category/mutations';
import { areSpecialFilters } from '~/assets/services/category';

export default function ({ store, query }) {
    const containSpecialFilter = areSpecialFilters(query);
    store.commit(`category/${types.SET_SPECIAL_FILTERS_STATE}`, containSpecialFilter);
}
